import { LoanStatus } from 'generated/graphql';

export const INELIGIBLE_STATUSES = [
  LoanStatus.TopUp,
  LoanStatus.SellOut,
  LoanStatus.OverAdvanced,
  LoanStatus.DataIssue,
];
